import { Resource } from "../resource";

export class Meta extends Resource {
    description: string;
    keywords:    string;
    title:       string;
    url:         string;
}
